import React from 'react';
import {Link} from 'react-router-dom';

export const ChooseLessor = React.createClass({
  componentDidMount() {
    window.sessionStorage.clear();
  },
  render() {
    return (
      <h1>wy.by</h1>
    );
  }
})


// WEBPACK FOOTER //
// ./src/visual/view/ChooseLessor.js